import { Text } from "@/components/typography";
import { Button } from "./Button";
import styles from "./ui.module.css";

export interface PaginationProps {
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export function Pagination({
  page,
  pageCount,
  onPageChange,
  className,
}: PaginationProps) {
  return (
    <nav className={className ? `${styles.pagination} ${className}` : styles.pagination} aria-label="Pagination">
      <Button
        variant="secondary"
        size="sm"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        Previous
      </Button>
      <Text role="small" color="secondary" as="span">
        Page {page} of {Math.max(pageCount, 1)}
      </Text>
      <Button
        variant="secondary"
        size="sm"
        disabled={page >= pageCount}
        onClick={() => onPageChange(page + 1)}
      >
        Next
      </Button>
    </nav>
  );
}
